// src/hooks/products/useDeleteProduct.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteProduct } from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const useDeleteProduct = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteProductMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteProduct,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete product");
        },
    });

    return {
        deleteProduct: deleteProductMutate,
        isDelete: isPending || isLoading,
    };
};

export default useDeleteProduct;
